import { render, staticRenderFns } from "./unit_edit_product.vue?vue&type=template&id=e96183d4&scoped=true"
import script from "./unit_edit_product.vue?vue&type=script&lang=js"
export * from "./unit_edit_product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96183d4",
  null
  
)

export default component.exports